export default {"src":"/_next/static/media/IIS.5e68e6f2.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};